import React, {useEffect, useRef, useState} from 'react';
import {Chart, ArcElement} from 'chart.js'
import 'chartjs-adapter-luxon';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

import {Bar} from "react-chartjs-2";
import {Line} from 'react-chartjs-2';
import {Doughnut} from 'react-chartjs-2';
import commaSeparator from "../../../utils/CommaSeparator";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
);
const ChartShow = ({type, title, options, data, sum}) => {
  const ref = useRef(null);
  // useEffect(() => {
  //   if (ref.current) {
  //     ref.current.height = 100;
  //   }
  // })

  // console.log(props.title)
  // //debugger
  // const [rnd, setRnd] = useState(Math.floor(Math.random() * 10000000));
  // useEffect(() => {
  //   setRnd(Math.floor(Math.random() * 10000000))
  //
  // }, [])


  // function createElementFromHTML(htmlString) {
  //   var div = document.createElement('div');
  //   div.innerHTML = htmlString.trim();
  //
  //   // Change this to div.childNodes to support multiple top-level nodes
  //   return div.firstChild;
  // }
  const style = `
    @media print{
        @page {
            size: A4 !important;
        }
        
        .top__chart__class{
            // max-width:60vw;
           display: block;
           // justify-content: center;
           padding:30px;
          // flex-wrap:wrap;
          // overflow: visible;
        }
    }

`;
  //debugger
  return data ?
    <div className={"top__chart__class"}>
      <div>
        <style>{style}</style>
        {type === 'bar'
          ?
          <div className={"border border-black"}>
            <Bar
              ref={ref}
              data={data}
              options={options}
              // style={{maxHeight: "50%",maxWidth: "15%"}}
            />
          </div>
          :
          type === 'doughnut' ? <div className={"border border-black"}>
              <Doughnut
                ref={ref}
                data={data}
                options={options}
                // style={{maxHeight: "50%",maxWidth: "15%"}}
              />
            </div> :
            type === "line" ?
              <Line
                ref={ref}
                data={data}
                options={options}
              />
              :
              <div>نوع چارت طبق استاندارد کامپوننت ها مشخص نشده</div>}
      </div>
    </div>
    :
    <>
      <div className={"text-center border border-black"}> داده ای موجود نیست</div>
    </>
};

export default ChartShow;
